import { supabase } from "@/integrations/supabase/client";

interface LogActivityParams {
  orgId: string;
  actionType: string;
  description: string;
  metadata?: Record<string, unknown>;
}

export async function logActivity({ orgId, actionType, description, metadata }: LogActivityParams) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  const { data: profile } = await supabase
    .from("profiles")
    .select("full_name")
    .eq("user_id", user.id)
    .maybeSingle();

  await supabase.from("activity_log").insert({
    org_id: orgId,
    actor_id: user.id,
    actor_name: profile?.full_name ?? "Unknown",
    action_type: actionType,
    description,
    metadata: (metadata ?? {}) as never,
  });
}
